import { FC } from "react";
import BemIt from "@gtechdoodler/bem-it";

import Icon from "../../../imagery/Icon";
import Typography from "../../../typography/Typography";

import { AccordionTitleProps } from "./AccordionTitle.types";
import { StyledAccordionTitle } from "./AccordionTitle.styles";
import { IconColorVariantOptions } from "../../../imagery/Icon/Icon.types";
import { resolvePaletteRoleForegroundToken } from "../../../../functions/resolvePaletteRoleForegroundToken";

const AccordionTitle: FC<AccordionTitleProps> = ({
	children,
	colorOn,
	isOpen,
	onClick,
}) => {
	const block = new BemIt("AccordionTitle");

	const icon = isOpen ? "chevron-up" : "chevron-down";
	const iconColor = resolvePaletteRoleForegroundToken(colorOn, 3).slice(
		3
	) as IconColorVariantOptions;

	return (
		<StyledAccordionTitle className={block.out} onClick={onClick}>
			<Typography
				htmlTag="h6"
				variant="body-large"
				weight="heaviest"
				colorOn={colorOn}
			>
				{children}
			</Typography>
			<Icon name={icon} size="md" color={iconColor} />
		</StyledAccordionTitle>
	);
};

export default AccordionTitle;
